import { render, staticRenderFns } from "./SensorDetails.html?vue&type=template&id=0b1e5ff1&scoped=true&external"
import script from "./SensorDetails.vue?vue&type=script&lang=js"
export * from "./SensorDetails.vue?vue&type=script&lang=js"
import style0 from "./SensorDetails.scss?vue&type=style&index=0&id=0b1e5ff1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1e5ff1",
  null
  
)

export default component.exports